<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">{{ $t('borrowingSparePart.pageTitle') }}</h1>
      <ts-breadcrumb
        :items="[
          { text: $t('home'), href: '/' },
          {
            text: $t('borrowingSparePart.pageTitle'),
            href: '/admin/borrowing-spare-parts'
          },
          {
            text: $t('generate'),
            active: true
          }
        ]"
      />
    </div>
    <ts-card>
      <ts-card-wrapper>
        <ts-loading-banner :loading="loading">
          <div
            class="ts-border ts-border-gray-300 ts-rounded-lg ts-p-3 ts-mb-3"
          >
            <form class="form-horizontal ts-space-y-2">
              <div class="row">
                <div class="col-md-6 ts-space-y-3">
                  <div class="row">
                    <label
                      class="col-md-3 form-col-label control-label required"
                      >{{ $t('borrowingSparePart.date') }}</label
                    >
                    <div class="col-md-9">
                      <a-date-picker
                        v-model="model.generate_date"
                        class="ts-w-full"
                        valueFormat="DD-MM-YYYY"
                        format="DD-MM-YYYY"
                      ></a-date-picker>
                      <div class="validate" v-if="errors.has('generate_date')">
                        {{ errors.first('generate_date') }}
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-6 ts-space-y-3">
                  <div class="row">
                    <label
                      class="col-md-3 form-col-label control-label required"
                      >{{ $t('borrowingSparePart.returnBy') }}</label
                    >
                    <div class="col-md-9">
                      <a-select
                        v-model="model.return_by"
                        :options="employeeList"
                        showSearch
                        :filterOption="
                          (input, option) =>
                            option.componentOptions.children[0].text
                              .toLowerCase()
                              .indexOf(input.toLowerCase()) >= 0
                        "
                        class="ts-w-full"
                      ></a-select>
                      <div class="validate" v-if="errors.has('return_by')">
                        {{ errors.first('return_by') }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-6 ts-space-y-3">
                  <div class="row">
                    <label
                      class="col-md-3 form-col-label control-label required"
                      >{{ $t('borrowingSparePart.borrowingNumber') }}</label
                    >
                    <div class="col-md-9">
                      <a-select
                        show-search
                        v-model="model.sfo_id"
                        mode="multiple"
                        :placeholder="$t('borrowingSparePart.searchSfo')"
                        style="width: 100%"
                        :default-active-first-option="false"
                        :show-arrow="false"
                        :filter-option="false"
                        :not-found-content="null"
                        @search="handleSearch"
                        @change="onSfoChange"
                      >
                        <a-select-option
                          v-for="p in serviceSFO"
                          :key="p.sfo_id"
                        >
                          {{ p.sfo_number + '|' + p.employee_name_kh }}
                        </a-select-option>
                      </a-select>
                      <div class="validate" v-if="errors.has('sfo_id')">
                        {{ errors.first('sfo_id') }}
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-6 ts-space-y-3">
                  <div class="row">
                    <label
                      class="col-md-3 form-col-label control-label"
                      :class="{
                        required: model.product_detail.some(
                          p => p.vendor_cover_percentage > 0
                        )
                      }"
                      >{{ $t('borrowingSparePart.vendorCustomer') }}</label
                    >
                    <div class="col-md-9">
                      <!-- <a-select
                        v-model="model.vendor_customer_id"
                        class="ts-w-full"
                        :options="customerList"
                        showSearch
                        :filterOption="
                          (input, option) =>
                            option.componentOptions.children[0].text
                              .toLowerCase()
                              .indexOf(input.toLowerCase()) >= 0
                        "
                      >
                      </a-select> -->
                      <a-select
                        show-search
                        v-model="model.vendor_customer_id"
                        style="width: 100%"
                        :default-active-first-option="false"
                        :show-arrow="false"
                        :filter-option="false"
                        :not-found-content="null"
                        @search="handleCustomerSearch"
                      >
                        <a-select-option
                          v-for="c in customerList"
                          :key="c.customer_id"
                        >
                          {{ c.customer_name }}
                        </a-select-option>
                      </a-select>
                      <div
                        class="validate"
                        v-if="errors.has('vendor_customer_id')"
                      >
                        {{ errors.first('vendor_customer_id') }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </div>
          <div class="ts-border ts-border-gray-300 ts-rounded-lg ts-p-3">
            <ProductInvoice v-model="model" ref="invoiceDetail" />
          </div>
          <div class="row ts-mt-4">
            <div class="col-md-12 ts-space-x-4 ts-flex ts-justify-end">
              <ts-button
                @click.prevent="$router.push({ name: 'borrowing-spare-part' })"
                >{{ $t('cancel') }}</ts-button
              >
              <ts-button color="primary" @click.prevent="onSave">{{
                $t('save')
              }}</ts-button>
            </div>
          </div>
        </ts-loading-banner>
      </ts-card-wrapper>
    </ts-card>
  </div>
</template>
<script>
import ProductInvoice from './components/product-detail-invoice.vue'
import { mapActions, mapState } from 'vuex'
import { debounce, join } from 'lodash'
import { Errors } from 'form-backend-validation'
import moment from 'moment'
export default {
  name: 'borrowingSparePartGenerateInvoice',
  components: {
    ProductInvoice
  },
  data() {
    return {
      loading: false,
      errors: new Errors(),
      model: {
        generate_date: moment().format('DD-MM-YYYY'),
        sfo_id: undefined,
        fx_rate_thb: 32,
        fx_rate_kh: 0,
        remarks: null,
        return_by: null,
        vendor_customer_id: null,
        product_detail: [],
        currency_id: 1,
        input_currency_id: 2,
        discount_rate: 0,
        input_discount_rate: 0,
        discount_type: '%',
        incentive_rate: 0,
        input_incentive_rate: 0,
        incentive_type: '%',
        grand_total: 0,
        input_grand_total: 0,
        product_id: 0,
        incentive_product_id: null
      }
    }
  },
  computed: {
    ...mapState('wholesale/borrowingSparePart', ['formModels', 'edit_data']),
    serviceSFO() {
      return this.formModels.serviceField
    },
    employeeList() {
      return this.formModels.employee.map(el => ({
        value: el.employee_id,
        label: el.employee_name_kh + '|' + el.employee_name_en
      }))
    },
    customerList() {
      if (!this.formModels.customer) return []
      return this.formModels.customer
      // .map(el => ({
      //   value: el.customer_id,
      //   label: el.customer_name
      // }))
    }
  },
  methods: {
    ...mapActions('wholesale/borrowingSparePart', [
      'getFormViewData',
      'combineInvoice',
      'generateInv'
    ]),
    onSave() {
      this.loading = true
      this.generateInv(this.model)
        .then(response => {
          this.$toasted.success(response.message)
          this.$router.push({ name: 'borrowing-spare-part' })
        })
        .catch(error => {
          this.errors = new Errors(error.errors)
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.loading = false
        })
    },
    async init({ params, index }) {
      this.loading = true
      await this.getFormViewData({ params: params, index: index })
      this.loading = false
    },
    setData(data) {
      this.model.fx_rate_kh = parseFloat(data[0].fx_rate_khr)
      this.model.product_id = data[0].product_id
      this.model.pro_group_id = data[0].pro_group_id
      this.model.product_detail = []

      this.getFormViewData({
        index: 'promotions',
        params: {
          fnName: 'promotions',
          product_id: data[0].product_id,
          pro_group_id: data[0].pro_group_id,
          service_request_id: data[0].service_request_id
        }
      })

      let detail = this.$refs.invoiceDetail

      data.forEach(item => {
        item.details.forEach(el => {
          this.model.product_detail.push({
            sfo_number: item.sfo_number,
            sfo_id: el.sfo_id,
            pro_group_id: el.product.pro_group_id,
            product_id: el.product_id,
            barcode: el.product.barcode,
            product_name: el.product.product_name_kh,
            sale_price: el.sale_price,
            vendor_standard_price: el.vendor_standard_price,
            uom_id: el.uom_id,
            quantity_order: el.quantity_order,
            quantity_return: el.quantity_return ? el.quantity_return : null,
            is_vendor_cover: el.discount_rate > 0 ? true : false,
            vendor_cover_percentage: el.discount_rate,
            customer_cover: true,
            customer_percentage: 100 - el.discount_rate,
            remarks: el.remarks,
            service_date: el.service_date,
            lost_qty: el.lost_qty,
            display_order: el.display_order
          })
          var exist = detail.tempDetails.find(
            p => p.product_id == el.product.product_id
          )
          if (!exist) {
            detail.tempDetails.push(el.product)
          }
        })
      })
    },
    handleSearch: debounce(async function(value) {
      this.loading = true
      await this.getFormViewData({
        index: 'serviceField',
        params: {
          fnName: 'serviceField',
          search_sfo_number: value
        }
      })
      this.loading = false
    }, 800),
    onSfoChange: debounce(async function(value) {
      if (value) {
        this.loading = true
        let response = await this.combineInvoice({
          filter: {
            sfo_id: join(value, ',')
          }
        })

        this.setData(response.data)

        this.loading = false
      }
    }, 800),
    handleCustomerSearch: debounce(async function(value) {
      this.loading = true
      await this.getFormViewData({
        index: 'customer',
        params: {
          fnName: 'customer',
          search_customer: value
        }
      })
      this.loading = false
    }, 800)
  },
  beforeRouteLeave(to, from, next) {
    this.$store.commit('wholesale/borrowingSparePart/SET_EDIT_DATA', [])
    next()
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.init({
        index: 'employee,product,customer,promotions,currency',
        params: {
          fnName: 'employee,product,customer,promotions,currency'
        }
      })
    })
  }
}
</script>
